export default {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};



// WEBPACK FOOTER //
// ./src/constants/message-category.js